// Native Run C, Part 4 (docs/NATIVE_RUN_C_SPEC.md, LB-200) — the app's push, through the
// bridge. src/ never imports a Capacitor module: native/entry.jsx exposes what the app may ask
// of the push plugin on window.LBNative, and this is the ONE module in src/ that reads it.
// Everything here is a no-op or "unavailable" on the web, where window.LBNative does not
// exist; the callers in components/onboarding/push.jsx reach these behind the native flag alone.
//
// What the bridge gives: push.available (iOS only — Android has no Firebase, LB-391),
// push.permission() → "granted" | "denied" | "prompt", push.register() → the APNs device
// token (hex), push.unregister(), push.onTap(cb). The token is remembered per DEVICE under
// lb_push_token, as a browser's push subscription is a device-level fact; which household it
// is registered with is PUSH_REG_KEY_PREFIX + code, exactly as on the web.

export function nativeBridge() {
  return typeof window !== "undefined" && window.LBNative ? window.LBNative : null;
}

export function nativePushAvailable() {
  const b = nativeBridge();
  return !!(b && b.push && b.push.available);
}

export async function nativePushPermission() {
  const b = nativeBridge();
  if (!b || !b.push || !b.push.available) return "unavailable";
  try { return await b.push.permission(); } catch { return "prompt"; }
}

// Resolves to the token; rejects with { denied: true } when refused.
export async function nativePushRegister() {
  const b = nativeBridge();
  if (!b || !b.push || !b.push.available) throw new Error("Push is not available in this app");
  return b.push.register();
}

export async function nativePushUnregister() {
  const b = nativeBridge();
  if (!b || !b.push || !b.push.available) return;
  try { await b.push.unregister(); } catch { /* best effort */ }
}

export function nativePushOnTap(cb) {
  const b = nativeBridge();
  if (!b || !b.push || typeof b.push.onTap !== "function") return () => {};
  return b.push.onTap(cb);
}

export const NATIVE_PUSH_TOKEN_KEY = "lb_push_token";
export function readNativePushToken() {
  try { return localStorage.getItem(NATIVE_PUSH_TOKEN_KEY) || null; } catch { return null; }
}
export function writeNativePushToken(token) {
  try { localStorage.setItem(NATIVE_PUSH_TOKEN_KEY, token); } catch {}
}
export function clearNativePushToken() {
  try { localStorage.removeItem(NATIVE_PUSH_TOKEN_KEY); } catch {}
}
